import { getLocal, setLocal } from "./storageUtils";

const ROUTE_CACHE_KEY = "sa_lax_route_cache";
const ROUTE_CACHE_TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

let _cache = null;

function loadRouteCache() {
  if (_cache) return _cache;
  const stored = getLocal(ROUTE_CACHE_KEY, null);
  if (stored && stored.ts && Date.now() - stored.ts < ROUTE_CACHE_TTL_MS) {
    _cache = stored.routes;
  } else {
    _cache = {}; // expired or missing — start fresh
  }
  return _cache;
}

function saveRouteCache(data) {
  _cache = data;
  setLocal(ROUTE_CACHE_KEY, { ts: Date.now(), routes: data });
}

// role: "in" for inbound lookups, "out" for outbound lookups.
// Falls back to the old unnamespaced key so existing cached routes still work.
function lookupRouteCache(flightCode, role = "in") {
  if (!flightCode || flightCode.length < 3) return null;
  const cache = loadRouteCache();
  const code  = flightCode.toUpperCase();
  return cache[`${role}:${code}`] || cache[code] || null;
}

// Called when an entry is saved -- stores inbound and outbound routes under separate keys
// so a turnaround flight (e.g. UA1652 LAS→LAX and UA1652 LAX→LAS) can't overwrite each other.
function learnRoutes(entry) {
  const cache = loadRouteCache();
  const inCode  = (entry.inFlt  || "").toUpperCase();
  const outCode = (entry.outFlt || "").toUpperCase();
  if (inCode  && entry.origin) cache[`in:${inCode}`]  = { origin: entry.origin, dest: "LAX" };
  if (outCode && entry.dest)   cache[`out:${outCode}`] = { origin: "LAX", dest: entry.dest };
  saveRouteCache(cache);
}

export { ROUTE_CACHE_KEY, lookupRouteCache, learnRoutes };
